import styled from "styled-components";

/* menu */
export const Photo = styled.div`
background-image: url(imgs/menu-main.webp);
// background-image: url(https://templatedemo.website.com/remote/imageProxy.cfc?method=viewLibraryImage&s=MCM5XzMmMyc5IzMnTCY0XEc8SS9MPyAgIAo%3D&w=1920);
height: 100vh;
background-size: cover;
position: relative;
`
// .menu .photo{
//     background-image: url(https://templatedemo.website.com/remote/imageProxy.cfc?method=viewLibraryImage&s=MCM5XzMmMyc5IzMnTCY0XEc8SS9MPyAgIAo%3D&w=1920);
//     height: 100vh;
//     background-size: cover;
//     position: relative;
//     }

export const Ul = styled.ul`
list-style: none;
display: flex;
justify-content: center;
align-items: center;
padding: 0;
`
    // .menu .container ul{
    //   list-style: none;
    //   display: flex;
    //   justify-content: center;
    //   align-items: center;
    // }

export const Li = styled.li`
margin-right: 5px;
background-color: #bd152b;
padding: 5px 10px;
border-radius: 5px;
font-weight: bold;
`
    // .menu .container ul li{
    //   margin-right: 5px;
    //   background-color: #bd152b;
    //   padding: 5px 10px;
    //   border-radius: 5px;
    //   font-weight: bold;
    // }

export const Items = styled.div`
display: grid;
grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
gap:20px;
text-align: center;
`    
// .menu .container .items{
//   display: grid;
//   grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
//   gap:20px;
// }

export const H3 = styled.h3`
color: #bd152b;
`
// .menu .container .items .item h3{
//   color: #bd152b;
// }

export const Span = styled.span`
color: #bd152b;
font-weight: bold;
`
// .menu .container .items .item span{
//   color: #bd152b;
//   font-weight: bold;
// }
    /* menu */
    